import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Image } from 'react-bootstrap';
import { BiUpload, BiHome, BiShow, BiHide } from 'react-icons/bi';

import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";

import { Breadcrumb } from 'react-bootstrap';
const ProfilePage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    country: '',
    state: '',
    city: '',
    postalCode: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [profilePreview, setProfilePreview] = useState(null);
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setProfilePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Profile Data:', formData);
    alert('Profile updated successfully!');
  };

  return (
    <Container   fluid className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Breadcrumb */}
       <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Profile</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
Pages
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Profile</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      <Card className="shadow-sm border-0">
        <Card.Body className="p-4">
          <h4 className="mb-4 pb-3 border-bottom">Profile</h4>

          <Form onSubmit={handleSubmit}>
            {/* Basic Information */}
            <h6 className="mb-4 fw-semibold">Basic Information</h6>

            <Row className="mb-5">
              <Col md={12} className="mb-4">
                <div className="d-flex align-items-center bg-light rounded-3 p-4">
                  <div className="me-4">
                    <div
                      className="border border-dashed border-2 rounded-circle d-flex align-items-center justify-content-center overflow-hidden"
                      style={{ width: '100px', height: '100px' }}
                    >
                      {profilePreview ? (
                        <Image
                          src={profilePreview}
                          alt="Profile"
                          roundedCircle
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <BiUpload size={50}  />
                      )}
                    </div>
                  </div>

                  <div>
                    <h6 className="mb-1">Profile Photo</h6>
                    <p className="text-muted small mb-3">
                      Recommended image size is 40px × 40px
                    </p>
                    <div className="d-flex gap-2">
                      <label  style={{background:"#ff6b1a"}} className="text-white border border-1 rounded rounder-2 btn-sm px-4 mb-0">
                        Upload
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageUpload}
                          hidden
                        />
                      </label>
                      <Button variant="light" size="sm" onClick={() => setProfilePreview(null)}>
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter first name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter last name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter phone number"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Address Information */}
            <h6 className="mb-4 fw-semibold">Address Information</h6>
            <Row className="mb-5">
              <Col md={12} className="mb-3">
                <Form.Group>
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Enter full address"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Form.Select name="country" value={formData.country} onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="India">India</option>
                    <option value="USA">USA</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Select name="state" value={formData.state} onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Select name="city" value={formData.city} onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="Chennai">Chennai</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleChange}
                    placeholder="600001"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Change Password */}
            <h6 className="mb-4 fw-semibold">Change Password</h6>
            <Row className="mb-5">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Current Password</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type={showCurrentPass ? 'text' : 'password'}
                      name="currentPassword"
                      value={formData.currentPassword}
                      onChange={handleChange}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                      onClick={() => setShowCurrentPass(!showCurrentPass)}
                      style={{ cursor: 'pointer' }}
                    >
                      {showCurrentPass ? <BiHide size={20} /> : <BiShow size={20} />}
                    </span>
                  </div>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type={showNewPass ? 'text' : 'password'}
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                      onClick={() => setShowNewPass(!showNewPass)}
                    >
                      {showNewPass ? <BiHide size={20} /> : <BiShow size={20} />}
                    </span>
                  </div>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type={showConfirmPass ? 'text' : 'password'}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                      onClick={() => setShowConfirmPass(!showConfirmPass)}
                    >
                      {showConfirmPass ? <BiHide size={20} /> : <BiShow size={20} />}
                    </span>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-3">
              <Button variant="light" type="button" onClick={() => window.location.reload()}>
                Cancel
              </Button>
              <Button  style={{background:"#ff6b1a"}}  type="submit" className="px-5 border border-2">
                Save
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      {/* <footer className="mt-4 text-center text-muted small">
        2014 - 2026 © SmartHR. Designed &amp; Developed By Dreams
      </footer> */}
    </Container>
  );
};

export default ProfilePage;